__webpack_require__.p = "/candidates-store/referrals/";